import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Claim } from '@core/model';
import { ClaimSearchDetailsService } from '@core/service';
import { noWhiteSpaceValidator } from '@mynexus/mynexus-ui-lib';

@Component({
    selector: 'app-claim-search-details',
    templateUrl: './claim-search-details.component.html',
    styleUrls: ['./claim-search-details.component.scss'],
    standalone: false
})
export class ClaimSearchDetailsComponent implements OnInit {

  @Input() tenantId: string;
  @Input() tenantName: string;
  claimSearchDetails: Claim;
  searchClaimByMemberDetailsForm: FormGroup;
  searchClaimByServiceDateDetailsForm: FormGroup;
  searchClaimByClaimIdDetailsForm: FormGroup;
  searchClaimByPatientControlNumberDetailsForm: FormGroup;
  yearOfBirthRange = `1900:${new Date().getFullYear()}`;
  birthDateMaxSelectableDate: Date = new Date();
  dateRangeOfServiceArray: any;
  newArr: any;

  constructor(private readonly router: Router, private claimSearchDetailsService : ClaimSearchDetailsService) {
    this.claimSearchDetails = { tenant: '', tenantId: '', subscriberNumber: '', memberlastname: '', memberdob: '' , startDate: '' , stopDate: '' , claimnumber: '' , patientcontrolnumber: '' };
  }

  ngOnInit(): void {
    this.initForms();
  }

  initForms()
  {
    this.searchClaimByMemberDetailsForm = new FormGroup({
      memberId: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      lastName: new FormControl('', [Validators.required,Validators.minLength(2),Validators.maxLength(50),noWhiteSpaceValidator]),
      dateOfBirth: new FormControl('', [Validators.required])
    });

    this.searchClaimByServiceDateDetailsForm = new FormGroup({
        dateRangeOfService: new FormControl('', [noWhiteSpaceValidator])
      }
    );

    this.searchClaimByClaimIdDetailsForm = new FormGroup({
        mynexusclaimid: new FormControl('', [Validators.maxLength(50),noWhiteSpaceValidator])
      }
    );

    this.searchClaimByPatientControlNumberDetailsForm = new FormGroup({
      patientcontrolnumber: new FormControl('', [Validators.maxLength(50),noWhiteSpaceValidator])
      }
    );
  }


  get memberIdClaimInput(): AbstractControl {
    return this.searchClaimByMemberDetailsForm.get('memberId');
  }

  get memberLastNameClaimInput(): AbstractControl {
    return this.searchClaimByMemberDetailsForm.get('lastName');
  }

  get memberDOBClaimInput(): AbstractControl {
    return this.searchClaimByMemberDetailsForm.get('dateOfBirth');
  }

  get dateRangeOfServiceClaimInput(): AbstractControl {
    return this.searchClaimByServiceDateDetailsForm.get('dateRangeOfService');
  }

  get myNexusClaimIdInput(): AbstractControl {
    return this.searchClaimByClaimIdDetailsForm.get('mynexusclaimid');
  }

  get patientControlNumberClaimInput(): AbstractControl {
    return this.searchClaimByPatientControlNumberDetailsForm.get('patientcontrolnumber');
  }

  onResetClaimForm() {
    this.searchClaimByMemberDetailsForm.reset();
    this.searchClaimByServiceDateDetailsForm.reset();
    this.searchClaimByClaimIdDetailsForm.reset();
    this.searchClaimByPatientControlNumberDetailsForm.reset();
    this.claimSearchDetailsService.setSearchClaimResult(null);
    this.router.navigate(['/', 'claims-search-by-details']);
  }

  onSearchClaim(){

    this.mapClaimSearchDetails();

    this.claimSearchDetailsService.getClaimsByDetails(this.claimSearchDetails).subscribe(
      res => {
        if(res !== null)
        {
          this.claimSearchDetailsService.setSearchClaimResult(res);
        }
        this.router.navigate(['/', 'claims-search-by-details']);
      }
    );

  }

  mapClaimSearchDetails()
  {
    sessionStorage.setItem('tenantName', this.tenantName);
    sessionStorage.setItem('tenantId', this.tenantId);

    this.claimSearchDetails = { tenant: '', tenantId: '', subscriberNumber: '', memberlastname: '', memberdob: '' , startDate: '' , stopDate: '' , id: 0 , patientcontrolnumber: '' };

    this.dateRangeOfServiceArray = !!this.searchClaimByServiceDateDetailsForm.value['dateRangeOfService'] ? this.searchClaimByServiceDateDetailsForm.controls['dateRangeOfService'].value.toString().split(",").filter((date) => { return date !== ''}) : '';

    if(this.dateRangeOfServiceArray?.length == 2)
    {
      this.claimSearchDetails.startDate = (new Date(this.dateRangeOfServiceArray[0])).toLocaleDateString();
      this.claimSearchDetails.stopDate = (new Date(this.dateRangeOfServiceArray[1])).toLocaleDateString();
    }
    else if (this.dateRangeOfServiceArray?.length == 1) {
      this.claimSearchDetails.startDate = (new Date(this.dateRangeOfServiceArray)).toLocaleDateString();
      this.claimSearchDetails.stopDate = (new Date(this.dateRangeOfServiceArray)).toLocaleDateString();
    }

    this.claimSearchDetails.tenant = this.tenantName;
    this.claimSearchDetails.tenantId = this.tenantId;

    this.claimSearchDetails.subscriberNumber = !!this.searchClaimByMemberDetailsForm.value['memberId'] ? this.searchClaimByMemberDetailsForm.controls['memberId'].value.toLocaleString() : '';

    this.claimSearchDetails.memberlastname = !!this.searchClaimByMemberDetailsForm.value['lastName'] ? this.searchClaimByMemberDetailsForm.controls['lastName'].value.toLocaleString() : '';
    this.claimSearchDetails.memberdob = !!this.searchClaimByMemberDetailsForm.value['dateOfBirth'] ? this.searchClaimByMemberDetailsForm.controls['dateOfBirth'].value.toLocaleString() : '';
    this.claimSearchDetails.memberdob = (this.claimSearchDetails.memberdob == '') ? '' : new Date(this.claimSearchDetails.memberdob).toLocaleDateString();
    this.claimSearchDetails.claimnumber = !!this.searchClaimByClaimIdDetailsForm.value['mynexusclaimid'] ? this.searchClaimByClaimIdDetailsForm.controls['mynexusclaimid'].value.toLocaleString().trim() : '';
    this.claimSearchDetails.patientcontrolnumber = !!this.searchClaimByPatientControlNumberDetailsForm.value['patientcontrolnumber'] ? this.searchClaimByPatientControlNumberDetailsForm.controls['patientcontrolnumber'].value.toLocaleString() : '';
  }

  disableBtn() {
    if (this.tenantName) {
      if (this.searchClaimByMemberDetailsForm.valid) {
        return false;
      } else {
        if (this.searchClaimByServiceDateDetailsForm.valid || this.searchClaimByClaimIdDetailsForm.valid || this.searchClaimByPatientControlNumberDetailsForm.valid) {

          const searchClaimByServiceDateDetailsFormValue = this.searchClaimByServiceDateDetailsForm.value?.dateRangeOfService;
          const searchClaimByClaimIdDetailsFormValue = this.searchClaimByClaimIdDetailsForm.value?.mynexusclaimid;
          const searchClaimByPatientControlNumberDetailsFormValue = this.searchClaimByPatientControlNumberDetailsForm.value?.patientcontrolnumber;

          return !((searchClaimByServiceDateDetailsFormValue !== null && searchClaimByServiceDateDetailsFormValue !== "")
            || (searchClaimByClaimIdDetailsFormValue !== null && searchClaimByClaimIdDetailsFormValue !== "")
            || (searchClaimByPatientControlNumberDetailsFormValue !== null && searchClaimByPatientControlNumberDetailsFormValue !== ""));
        }
      }
    }
    return true;
  }
}
